import { Icon, Popup } from "semantic-ui-react";
import Expandable from "../../../../../components/shared/Expandable";
import CircularButton from "../../../../../components/shared/circularbutton/CircularButton";
import SubnetItem from "./SubnetItem";
import useSubnetsList from "./hooks/useSubnetsList";
import { useNetworkFormContext } from "../context/NetworkFormContext";

const SubnetsList = () => {
  const { subnets, onAddSubnet, nameservers, handleSingleSubnetChange } =
    useSubnetsList();

  const { subnetRefs } = useNetworkFormContext();

  return (
    <Expandable
      defaultOpened={true}
      title="Subnets "
      subtitle={`(${subnets?.length} defined.)`}
      titlePopup={
        <Popup
          trigger={<Icon name="question circle" className="margin-left-half" />}
          content={
            <div className="padding-top-half padding-right-half padding-bottom-half padding-left-half">
              <p>
                Worker groups within the Gardener shoot are used to run
                containerized applications.
              </p>
              <p>
                They also support network configurations and provide secure
                isolation of in-session and out-of-session connectivity.
              </p>
            </div>
          }
        />
      }
      button={
        <CircularButton
          className="float-right button button--circular button--orange margin-left-00"
          onClick={onAddSubnet}
          icon="plus"
          popupContent="Add one more worker group to this shoot"
        />
      }
    >
      {subnets?.map((_, index) => (
        <SubnetItem
          nameservers={nameservers}
          key={index}
          index={index}
          onChange={handleSingleSubnetChange}
          ref={subnetRefs[index]}
        />
      ))}
    </Expandable>
  );
};

export default SubnetsList;
